//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import caReader from '@components-sys/ca-reader'

export default {
    props: [],
    components: {caReader},
    data () {
        return {
            dialogVisible: false,

            form: {
                truename: '',
                userid: '',
                cacertname: '-',
                cacertb64: '-'
            },

            stepController: 0
        }
    },
    computed: {
        dialogTitle() {
            return '绑定CA-' + this.form.truename
        }
    },
    methods: {
        show() {
            this.dialogVisible = true;
        },
        hide() {
            this.dialogVisible = false;
        },
        stepHandler() {
            this.stepController = 1
        },
        setInfo(name, id) {
            this.form.userid = id;
            this.form.truename = name;
        },
        bindHandler() {
            this.$post(this.getStore('sysUrl') + '/user/cabind', this.form, (data, res) => {
                ShowMsg.call(this, res.msg);
                this.hide();
                this.$emit('bind');
            })
        }
    },
    watch: {
        dialogVisible(n) {
            if(!n) {
                this.stepController = 0;
                this.form = {
                    truename: '',
                    userid: '',
                    cacertname: '-',
                    cacertb64: '-'
                };
            }
        }
    },
    mounted: function() {

    }
}
